import { render, staticRenderFns } from "./SiskeudesPotonganTable.vue?vue&type=template&id=42e39626&lang=pug"
import script from "./SiskeudesPotonganTable.vue?vue&type=script&lang=js"
export * from "./SiskeudesPotonganTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports